export const springA = {
	delay: 0,
	config: {
		damping: 200,
	},
};

export const springB = {
	delay: 15,
	config: {
		damping: 200,
	},
};

export const springC = {
	delay: 24,
	config: {
		damping: 200,
	},
};

export const springD = {
	delay: 30,
	config: {
		damping: 200,
	},
};
